import React from 'react'
import cx from 'classnames'
import { getFileNameParts } from '@bikemap/js/utility/helpers'

import styles from './Picture.module.scss'

/**
 * Show image with optimized sizes (@2x and @3x) and optional .webp format.
 * @param {Object} props
 * @param {string} props.className Additional custom className
 * @param {string} props.src Full path to original image
 * @param {boolean} [props.hasWebp] If there are .webp versions
 * @param {string} props.width Can be overwritten in CSS, but it's required to minimize CLS
 * @param {string} props.height Can be overwritten in CSS, but it's required minimize CLS
 * @param {string} [props.alt]
 * @param {boolean} [props.isFullWidth] If it should spread full width
 */
const Picture = (props) => {
    const {
        className,
        src,
        hasWebp,
        width,
        height,
        alt,
        isFullWidth,
    } = props

    const classNames = cx({
        [styles.fullWidth]: !!isFullWidth,
        [className]: !!className,
    })

    const [base, ext] = getFileNameParts(src)
    const areSrcPartsFound = (base && ext)

    return (
        <picture className={classNames}>
            {(areSrcPartsFound && hasWebp) && (
                <source
                    srcSet={base + '.webp 1x, ' + base + '@2x.webp 2x, ' + base + '@3x.webp 3x'}
                    type='image/webp'
                />
            )}
            {areSrcPartsFound && (
                <source
                    srcSet={base + '.' + ext + ' 1x, ' + base + '@2x.' + ext + ' 2x, ' + base + '@3x.' + ext + ' 3x'}
                    type={'image/' + ext}
                />
            )}
            <img
                className={classNames}
                src={src}
                srcSet={areSrcPartsFound ? (base + '@2x.' + ext + ' 2x, ' + base + '@3x.' + ext + ' 3x') : ''}
                width={width}
                height={height}
                alt={alt || ''}
                decoding='async'
            />
        </picture>
    )
}

export default Picture
